export const InvoiceDocumentTypeEnum = {
    INBOUND: 0,
    OUTBOUND: 1,
    SHIPPING: 2,
};

export const InvoiceDocumentStateEnum = {
    CREATED: 0,
    IN_PROGRESS: 1,
    DONE: 2,
    CANCELLED: 3,
    DEVOLUTION: 4,
    SHIPPING: 5,
};
